import React from 'react';
import PropTypes from 'prop-types';
import OptimizedImage from './OptimizedImage';

const CategoryHeader = props => {
  const { title = '', subtitle = '', body = '', imageUrl = '' } = props;

  return (
    <section className="width-wrapper">
      <div className="category-header">
        <OptimizedImage
          imageUrl={imageUrl}
          className={`category-header-image`}
          title={title}
        />
        <div className="category-header-text">
          <h1>{title}</h1>
          <h2>{subtitle}</h2>
          <p>{body}</p>
        </div>
      </div>
    </section>
  );
};

CategoryHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  body: PropTypes.string,
  imageUrl: PropTypes.string
};

export default CategoryHeader;
